import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { Edit, MoreVert } from "@mui/icons-material";
import InactivateModal from "./InactivateModal";
import NoAccountsOutlinedIcon from "@mui/icons-material/NoAccountsOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import ActivateModal from "./ActivateModal";

const RowActions = ({ row, table, onActivate, onInactivate }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [openActivateModal, setOpenActivateModal] = React.useState(false);
  const [openInactivateModal, setOpenInactivateModal] = React.useState(false);

  const handleOpenActivateModal = () => setOpenActivateModal(true);
  const handleOpenInactivateModal = () => setOpenInactivateModal(true);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton onClick={handleMenuOpen}>
        <MoreVert />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            table.setEditingRow(row);
            handleMenuClose();
          }}
        >
          <Edit fontSize="small" style={{ marginRight: 8 }} />
          Edit
        </MenuItem>
        {row?.status === "inactivated" ? (
          <MenuItem
            onClick={() => {
              handleOpenActivateModal();
              handleMenuClose();
            }}
          >
            <VerifiedUserOutlinedIcon
              fontSize="small"
              style={{ marginRight: 8, color: "green" }}
            />
            Activate
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => {
              handleOpenInactivateModal();
              handleMenuClose();
            }}
          >
            <NoAccountsOutlinedIcon
              fontSize="small"
              style={{ marginRight: 8, color: "red" }}
            />
            Inactivate
          </MenuItem>
        )}
      </Menu>

      <ActivateModal
        openModal={openActivateModal}
        setOpenModal={setOpenActivateModal}
        row={row}
        onActivate={onActivate}
      />
      <InactivateModal
        openModal={openInactivateModal}
        setOpenModal={setOpenInactivateModal}
        row={row}
        onInactivate={onInactivate}
      />
    </Box>
  );
};

export default RowActions;
